
        <div [ngClass]="{'spinner': true, 'is-button': isButton, 'black': isBlack}">
            <div class="rect rect1"></div>
            <div class="rect rect2"></div>
            <div class="rect rect3"></div>
            <div class="rect rect4"></div>
            <div class="rect rect5"></div>
            <div class="label-spinner" *ngIf="label">{{label}}</div>
        </div>
    